export default __webpack_public_path__ + "static/media/CoalOre.256.0cf583a3.png";